export enum TemperatureMeasurement {
    Celsius,
    Fahrenheit
}
